// extracted by mini-css-extract-plugin
module.exports = {"mappedReview":"customerReviewPage_mappedReview__7z6ZJ","fadein":"customerReviewPage_fadein__c7zRA","loading":"customerReviewPage_loading__XZch3"};